<template>
    <div class="results-box">
        <h3>Engagement Outcome based on your Messaging</h3>
        <bar-chart :chartData="chartData" :showEnding="showEnding"></bar-chart>
        <br>
        <p v-html="content"></p>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import BarChart from '@/components/BarChart.vue'

export default {
    name : "ChartFeedback",
    components : {
        'bar-chart' : BarChart
    },
    computed: {
        ...mapGetters([
            "getMeta",
            "playerTotal",
            "getScoring"
        ]),
        chartData(){
            const dt = this.playerTotal
            const scores = this.getMeta.scores
            const keys = Object.keys( dt )
            const out = []

            keys.forEach( key => {
                const data = scores[ key ]
                if( data ){
                    data.userScore += dt[ key ]
                    out.push( data )
                }
            })
            return out
        },
        showEnding(){
            return true
        },
        content(){
            return this.getScoring.engagement.content
        }
    }
}
</script>
<style lang="scss">
    
</style>